import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { TAlert } from '../../types';

export type AlertServiceType = { alert: TAlert; data?: any };

@Injectable({
  providedIn: 'root'
})
export class AlertMessageService {
  private alert$: Subject<AlertServiceType | undefined> = new Subject<
    AlertServiceType | undefined
  >();

  next(data?: AlertServiceType): void {
    this.alert$.next(data);
  }

  alertMessage(): Observable<{ alert: TAlert; data?: any } | undefined> {
    return this.alert$.asObservable();
  }
}
